export const getNestedUnitForQuantity = <T>(
  items: T[] | undefined,
  unitExtrator: (item: T) => string,
) => {
  if (!items || items.length === 0) {
    return null;
  }

  const firstUnit = unitExtrator(items[0]);
  const isEveryUnitEqual = items.every(item => unitExtrator(item) === firstUnit);

  return isEveryUnitEqual ? firstUnit : null;
}
